import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Play from "./pages/Play";
import Admin from "./pages/Admin";
import Documents from "./pages/Documents";
import { WalletProvider } from "./context/WalletContext";

function App() {
  return (
    <div className="App">
      <WalletProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/play" element={<Play />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/documents" element={<Documents />} />
          </Routes>
        </BrowserRouter>
      </WalletProvider>
    </div>
  );
}

export default App;
